import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'admissions-commitments-tab-2-part',
	standalone:true,
	templateUrl: './admissions-commitments-tab-2.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./admissions-commitments-tab-2.part.scss`],
})
export class AdmissionsCommitmentsTab2Part {
}
